<script setup>
import { inject, computed } from 'vue'

const props = defineProps({
  tag: {
    type: String,
    default: 'div'
  },
  name: {
    type: [String, Number],
    required: true
  }
})

const { activeNames } = inject('collapse')

const isActive = computed(() => {
  return Array.isArray(activeNames.value)
    ? activeNames.value.includes(props.name)
    : activeNames.value === props.name
})
</script>

<template>
  <Transition
    name="collapse-transition"
    @before-enter="(el) => el.style.height = '0'"
    @enter="(el) => el.style.height = el.scrollHeight + 'px'"
    @after-enter="(el) => el.style.height = ''"
    @before-leave="(el) => el.style.height = el.scrollHeight + 'px'"
    @leave="(el) => el.style.height = '0'"
  >
    <component
      :is="tag"
      v-show="isActive"
      v-bind="$attrs"
      class="collapse-content"
    >
      <slot />
    </component>
  </Transition>
</template>

<style lang="less">
.collapse-content {
  overflow: hidden;
}

.collapse-transition-enter-active,
.collapse-transition-leave-active {
  transition: height 0.3s ease-in-out;
}
</style>
